// Block reordering siblings when a list contains Submit/Save (EditHeader + changes.ts).
import * as DocConvertPlainText from "./Convert/PlainText";

export function buttonTitleText(node: DocBlockNode<unknown>): string {
  if (node.type !== "button" || !("title" in node)) {
    return "";
  }

  return DocConvertPlainText.fromAnyType((node as DocButtonType<unknown>).title).trim();
}

export function isSubmitButtonNode(node: DocBlockNode<unknown>): boolean {
  return node.type === "button" && buttonTitleText(node).toLowerCase() === "submit";
}

export function isSaveButtonNode(node: DocBlockNode<unknown>): boolean {
  return node.type === "button" && buttonTitleText(node).toLowerCase() === "save";
}

export function isSubmitOrSaveButtonNode(node: DocBlockNode<unknown>): boolean {
  return isSubmitButtonNode(node) || isSaveButtonNode(node);
}

// Sibling array includes Submit or Save.
export function siblingContentArrayHasSubmitOrSaveButton(
  siblings: Array<DocBlockNode<unknown>> | undefined,
): boolean {
  if (!Array.isArray(siblings)) {
    return false;
  }

  return siblings.some(isSubmitOrSaveButtonNode);
}

// Direct child of that array; nested children (e.g. MC answers) are not locked.
export function isDirectChildAtSubmitButtonLevel(
  parent: DocBlockNode<unknown>,
  parentContentKey: string,
): boolean {
  const siblings = parent[parentContentKey as keyof typeof parent];
  return siblingContentArrayHasSubmitOrSaveButton(
    siblings as unknown as Array<DocBlockNode<unknown>> | undefined,
  );
}
